export default {
  grayHeader: "配送方法について",
  listTitle: "商品は手渡しにて受取りサイン必須です。",
  subHeading: 'お届けまでの所要日数',
  content: {
    additions: [
      "ゆうパックにて出荷いたします。",
      "配送料は1ヶ所あたり全国一律600円でお届けいたします。",
      "商品を複数ご注文の場合、配送の「お届け先」「差出人」の両方が同一であれば【1ヶ所】として承ることができます。",
      "商品出荷後、「注文確認」ページに配送会社のお問い合わせ番号が記載されます。",
      "配送状況の確認や配送日の変更希望等は、直接配送会社にご連絡ください。",
      "配達時にご不在の場合、不在票を投函いたします。保管期間がございますのでお早めに再配達依頼をしてください。",
      "郵便局受取り（局留）はご利用いただけませんのでご注意ください。"
    ]
  },
  duration: {
    paymentMethod: 'お支払い方法',
    shipment: '商品の出荷',
    transportDay: 'お届け日数',
    scheduledDelivery: 'お届け日の指定',
    bank: {
      additions: [
        {
          title: "お支払い方法",
          bodyPC: "銀行振込",
          bodySP: "銀行振込"
        },
        {
          title: "商品の出荷",
          bodyPC: "弊社にて着金確認後、\n3〜4日後（土日祝除く）に出荷",
          bodySP: "弊社にて着金確認後、3〜4日後（土日祝除く）に出荷"
        },
        {
          title: "お届け日数",
          bodyPC: "出荷後1〜3日でお届け",
          bodySP: "出荷後1〜3日でお届け",
          tips: [
            "配送地域・当日の天候・交通状況により遅れる場合があります。",
            "ゴールデンウイーク、母の日、父の日、お盆、クリスマス〜年末年始は各地域で＋2〜3日程度かかる場合がございます。"
          ]
        },
        {
          title: "お届け日の指定",
          bodyPC: "不可",
          bodySP: "不可",
        }
      ]
    },
    credit: {
      additions: [
        {
          title: "お支払い方法",
          bodyPC: "クレジットカード",
          bodySP: "クレジットカード"
        },
        {
          title: "商品の出荷",
          bodyPC: "購入画面で注文完了後、\n3〜4日後（土日祝除く）に出荷",
          bodySP: "購入画面で注文完了後、3〜4日後（土日祝除く）に出荷"
        },
        {
          title: "お届け日数",
          bodyPC: "出荷後1〜3日でお届け",
          bodySP: "出荷後1〜3日でお届け",
          tips: [
            "配送地域・当日の天候・交通状況により遅れる場合があります。",
            "ゴールデンウイーク、母の日、父の日、お盆、クリスマス〜年末年始は各地域で＋2〜3日程度かかる場合がございます。"
          ]
        },
        {
          title: "お届け日の指定",
          bodyPC: "可",
          bodySP: "可",
          tips: [
            "購入の10日後よりご指定可能です。"
          ]
        }
      ]
    }
  }
};



// WEBPACK FOOTER //
// ./src/i18n/ja/about/delivery/index.js